import { Injectable, signal } from '@angular/core';
import type { VhOtpPurpose } from '@vendorhub/shared/data-access';

/**
 * Carries the `publicId` / phone context between register → verify-email →
 * verify-phone pages without putting identifiers in the URL. Cleared on
 * full verification or on log-out.
 */
@Injectable({ providedIn: 'root' })
export class PendingVerificationStore {
  private readonly _publicId = signal<string | null>(null);
  private readonly _email = signal<string | null>(null);
  private readonly _phoneNumber = signal<string | null>(null);
  private readonly _purpose = signal<VhOtpPurpose>('verify');

  readonly publicId = this._publicId.asReadonly();
  readonly email = this._email.asReadonly();
  readonly phoneNumber = this._phoneNumber.asReadonly();
  readonly purpose = this._purpose.asReadonly();

  setFromRegister(publicId: string, email: string, phoneNumber: string | null): void {
    this._publicId.set(publicId);
    this._email.set(email);
    this._phoneNumber.set(phoneNumber);
    this._purpose.set('verify');
  }

  setPhone(phoneNumber: string, purpose: VhOtpPurpose): void {
    this._phoneNumber.set(phoneNumber);
    this._purpose.set(purpose);
  }

  clear(): void {
    this._publicId.set(null);
    this._email.set(null);
    this._phoneNumber.set(null);
    this._purpose.set('verify');
  }
}
